export default __webpack_public_path__ + "static/media/person.534973c0.svg";